module.exports = __webpack_public_path__ + "8fc2a6c4af01503040a01320bf819f1e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pattern/5.svg
// module id = 700
// module chunks = 0